import { DOC_TYPE_ID, USER_ROLES_IDS, VisitorType } from "../constants/common";
import * as Yup from "yup";
import i18n from "../i18n";

export const createVIPSchema = (visitPurposes: any, roleId?: number) => {
  const isSecurity = roleId === USER_ROLES_IDS.SECURITY;

  return Yup.object({
    name: Yup.string()
      .required(i18n.language === "en" ? "Name is required." : "الاسم مطلوب.")
      .matches(
        /^[^0-9]*$/,
        i18n.language === "en"
          ? "Name must not contain numbers."
          : "يجب ألا يحتوي الاسم على أرقام."
      ),
    companyName: Yup.string().when("visitReqType", {
      is: VisitorType.VVIP,
      then: (schema) => schema.notRequired(),
      otherwise: (schema) =>
        schema.required(
          i18n.language === "en"
            ? "Organization name is required."
            : "الجهة التابع لها مطلوب."
        ),
    }),
    nationality: Yup.string().when("visitReqType", {
      is: VisitorType.VVIP,
      then: (schema) => schema.notRequired(),
      otherwise: (schema) =>
        schema.required(
          i18n.language === "en"
            ? "Nationality is required."
            : "الجنسية مطلوبة."
        ),
    }),
    number: Yup.string().when("visitReqType", {
      is: VisitorType.VVIP,
      then: (schema) => schema.notRequired(),
      otherwise: (schema) =>
        schema
          .matches(
            /^\d{1,14}$/,
            i18n.language === "en"
              ? "Enter a valid number."
              : "أدخل رقماً صحيحاً."
          )
          .required(
            i18n.language === "en"
              ? "Mobile Number is required."
              : "رقم الجوال مطلوب."
          ),
    }),
    email: Yup.string()
      .email(
        i18n.language === "en" ? "Invalid email" : "البريد الإلكتروني غير صالح."
      )
      .required(
        i18n.language === "en"
          ? "Email is required."
          : "البريد الإلكتروني مطلوب."
      ),
    dateOfBirth: Yup.string().when("visitReqType", {
      is: VisitorType.VVIP,
      then: (schema) => schema.notRequired(),
      otherwise: (schema) =>
        schema.required(
          i18n.language === "en"
            ? "Date of birth is required."
            : "تاريخ الميلاد مطلوب."
        ),
    }),

    idType: Yup.number().when("visitReqType", {
      is: VisitorType.VVIP,
      then: (schema) => schema.notRequired(),
      otherwise: (schema) =>
        schema.required(
          i18n.language === "en" ? "ID Type is required." : "نوع الهوية مطلوب."
        ),
    }),

    iqama: Yup.string().when("visitReqType", {
      is: VisitorType.VVIP,
      then: (schema) => schema.notRequired(),
      otherwise: (schema) =>
        schema.nullable().when("idType", {
          is: DOC_TYPE_ID.IQAMA,
          then: (schema) =>
            schema
              .matches(
                /^\d{1,10}$/,
                i18n.language === "en"
                  ? "Enter a valid iqama number."
                  : "أدخل رقم إقامة صالحاً."
              )
              .required(
                i18n.language === "en"
                  ? "Iqama is required."
                  : "الإقامة مطلوبة."
              ),
          otherwise: (schema) => schema.nullable(),
        }),
    }),
    iqamaExpiryDate: Yup.string()
      .optional()
      .when("visitReqType", {
        is: VisitorType.VVIP,
        then: (schema) => schema.notRequired(),
        otherwise: (schema) =>
          schema.nullable().when("idType", {
            is: DOC_TYPE_ID.IQAMA,
            then: (schema) =>
              schema.required(
                i18n.language === "en"
                  ? "Iqama expiry is required."
                  : "تاريخ انتهاء الإقامة مطلوب."
              ),
            otherwise: (schema) => schema.nullable(),
          }),
      }),

    eid: Yup.string().when("visitReqType", {
      is: VisitorType.VVIP,
      then: (schema) => schema.notRequired(),
      otherwise: (schema) =>
        schema.nullable().when("idType", {
          is: DOC_TYPE_ID.NATIONAL_ID,
          then: (schema) =>
            schema
              .matches(
                /^\d{1,10}$/,
                i18n.language === "en"
                  ? "Enter a valid National ID."
                  : "أدخل رقم هوية وطنية صالحاً."
              )
              .required(
                i18n.language === "en"
                  ? "National ID is required."
                  : "الهوية الوطنية مطلوبة."
              ),
          otherwise: (schema) => schema.nullable(),
        }),
    }),
    eidExpiryDate: Yup.string()
      .optional()
      .when("visitReqType", {
        is: VisitorType.VVIP,
        then: (schema) => schema.notRequired(),
        otherwise: (schema) =>
          schema.nullable().when("idType", {
            is: DOC_TYPE_ID.NATIONAL_ID,
            then: (schema) =>
              schema.required(
                i18n.language === "en"
                  ? "National ID expiry is required."
                  : "تاريخ انتهاء الهوية الوطنية مطلوب."
              ),
            otherwise: (schema) => schema.nullable(),
          }),
      }),
    passportNumber: Yup.string().when("visitReqType", {
      is: VisitorType.VVIP,
      then: (schema) => schema.notRequired(),
      otherwise: (schema) =>
        schema.nullable().when("idType", {
          is: DOC_TYPE_ID.PASSPORT,
          then: (schema) =>
            schema.required(
              i18n.language === "en"
                ? "Passport Number is required."
                : "رقم جواز السفر مطلوب."
            ),
          otherwise: (schema) => schema.nullable(),
        }),
    }),
    passportExpiryDate: Yup.string()
      .optional()
      .when("visitReqType", {
        is: VisitorType.VVIP,
        then: (schema) => schema.notRequired(),
        otherwise: (schema) =>
          schema.nullable().when("idType", {
            is: DOC_TYPE_ID.PASSPORT,
            then: (schema) =>
              schema.required(
                i18n.language === "en"
                  ? "Passport expiry date is required."
                  : "تاريخ انتهاء جواز السفر مطلوب."
              ),
            otherwise: (schema) => schema.nullable(),
          }),
      }),

    idTypeOtherName: Yup.string().when("visitReqType", {
      is: VisitorType.VVIP,
      then: (schema) => schema.notRequired(),
      otherwise: (schema) =>
        schema.nullable().when("idType", {
          is: DOC_TYPE_ID.OTHER,
          then: (schema) =>
            schema.required(
              i18n.language === "en"
                ? "Document name is required."
                : "اسم المستند مطلوب."
            ),
          otherwise: (schema) => schema.nullable(),
        }),
    }),
    idTypeOtherNumber: Yup.string().when("visitReqType", {
      is: VisitorType.VVIP,
      then: (schema) => schema.notRequired(),
      otherwise: (schema) =>
        schema.nullable().when("idType", {
          is: DOC_TYPE_ID.OTHER,
          then: (schema) =>
            schema
              .max(
                20,
                i18n.language === "en"
                  ? "Enter a valid document number."
                  : "أدخل رقم مستند صالحاً."
              )
              .required(
                i18n.language === "en"
                  ? "Document number is required."
                  : "رقم المستند مطلوب."
              ),
          otherwise: (schema) => schema.nullable(),
        }),
    }),
    idTypeOtherExpiryDate: Yup.string()
      .optional()
      .when("visitReqType", {
        is: VisitorType.VVIP,
        then: (schema) => schema.notRequired(),
        otherwise: (schema) =>
          schema.nullable().when("idType", {
            is: DOC_TYPE_ID.OTHER,
            then: (schema) =>
              schema.required(
                i18n.language === "en"
                  ? "Document expiry date is required."
                  : "تاريخ انتهاء المستند مطلوب."
              ),
            otherwise: (schema) => schema.nullable(),
          }),
      }),

    visaNumber: Yup.string().when("visitReqType", {
      is: VisitorType.VVIP,
      then: (schema) => schema.notRequired(),
      otherwise: (schema) =>
        schema.nullable().when("idType", {
          is: DOC_TYPE_ID.VISA,
          then: (schema) =>
            schema
              .required(
                i18n.language === "en"
                  ? "Visa number is required"
                  : "رقم التأشيرة مطلوب"
              )
              .matches(
                /^[A-Z0-9][A-Z0-9\s-]{5,13}$/,
                i18n.language === "en"
                  ? "Enter a valid visa number"
                  : "أدخل رقم تأشيرة صالحًا"
              ),
          otherwise: (schema) => schema.nullable(),
        }),
    }),
    visaExpiryDate: Yup.string()
      .optional()
      .when("visitReqType", {
        is: VisitorType.VVIP,
        then: (schema) => schema.notRequired(),
        otherwise: (schema) =>
          schema.nullable().when("idType", {
            is: DOC_TYPE_ID.VISA,
            then: (schema) =>
              schema.required(
                i18n.language === "en"
                  ? "Visa Expiry Date is required."
                  : "يجب تحديد تاريخ انتهاء صلاحية التأشيرة."
              ),
            otherwise: (schema) => schema.nullable(),
          }),
      }),

    plateSource: Yup.string().when("$isVehicleInfoVisible", {
      is: true,
      then: (schema) =>
        schema.required(
          i18n.language === "en"
            ? "Plate Source is required."
            : "مصدر اللوحة مطلوب."
        ),
      otherwise: (schema) => schema.nullable(),
    }),
    plateNumber: Yup.string()
      .nullable()
      .when("$isVehicleInfoVisible", {
        is: true,
        then: (schema) =>
          schema
            .matches(
              /^[0-9\u0660-\u0669]{1,6}$/,
              i18n.language === "en"
                ? "Enter a valid plate number."
                : "أدخل رقم لوحة صالح."
            )
            .required(
              i18n.language === "en"
                ? "Plate Number is required."
                : "رقم اللوحة مطلوب."
            ),
        otherwise: (schema) => schema.nullable(),
      }),
    plateLetter1: Yup.string().when("$isVehicleInfoVisible", {
      is: true,
      then: (schema) =>
        schema.required(
          i18n.language === "en"
            ? "Plate Letter 1 is required."
            : "الحرف الأول من اللوحة مطلوب."
        ),
      otherwise: (schema) => schema.nullable(),
    }),
    plateLetter2: Yup.string().when("$isVehicleInfoVisible", {
      is: true,
      then: (schema) =>
        schema.required(
          i18n.language === "en"
            ? "Plate Letter 2 is required."
            : "الحرف الثاني من اللوحة مطلوب."
        ),
      otherwise: (schema) => schema.nullable(),
    }),
    plateLetter3: Yup.string().when("$isVehicleInfoVisible", {
      is: true,
      then: (schema) =>
        schema.required(
          i18n.language === "en"
            ? "Plate Letter 3 is required."
            : "الحرف الثالث من اللوحة مطلوب."
        ),
      otherwise: (schema) => schema.nullable(),
    }),

    location: Yup.string().required(
      i18n.language === "en" ? "Location is required." : "الموقع مطلوب."
    ),
    building: Yup.string().required(
      i18n.language === "en" ? "Building is required." : "مطلوب بناء"
    ),
    visitingDepartment: Yup.string().when("visitReqType", {
      is: VisitorType.VVIP,
      then: (schema) => schema.notRequired(),
      otherwise: (schema) =>
        schema.required(
          i18n.language === "en" ? "Department is required." : "القسم مطلوب."
        ),
    }),
    visitReqType: Yup.string().required(
      i18n.language === "en"
        ? "Visit Request Type is required."
        : "نوع طلب الزيارة مطلوب."
    ),
    visitPurpose: Yup.string().when("visitReqType", {
      is: VisitorType.VVIP,
      then: (schema) => schema.notRequired(),
      otherwise: (schema) =>
        schema.required(
          i18n.language === "en" ? "Purpose is required." : "الغرض مطلوب."
        ),
    }),
    visitPurposeOther: Yup.string().when(["visitPurpose"], {
      is: (visitPurpose: string) => {
        const purpose =
          visitPurposes?.find(
            (item: any) => item.value === Number(visitPurpose)
          )?.labelEn || "";

        return purpose.trim() === "Other";
      },
      then: (schema) =>
        schema
          .matches(
            /^.{1,50}$/,
            i18n.language === "en"
              ? "Visit purpose (Other) must not exceed 50 characters."
              : "الغرض الآخر لا يجب أن يتجاوز 50 حرفًا."
          )
          .required(
            i18n.language === "en"
              ? "Visit purpose (Other) is required."
              : "الغرض الآخر مطلوب."
          ),
      otherwise: (schema) => schema.notRequired(),
    }),
    hostEmail: Yup.string().required(
      i18n.language === "en"
        ? "Host email is required."
        : "البريد الإلكتروني للمضيف مطلوب."
    ),
    hostMobileNumber: Yup.string()
      .required(
        i18n.language === "en"
          ? "Host mobile number is required."
          : "رقم الهاتف المحمول المضيف مطلوب."
      )
      .matches(
        /^\d{1,14}$/,
        i18n.language === "en" ? "Enter a valid number." : "أدخل رقمًا صالحًا."
      ),
    visitStartDate: Yup.string().required(
      i18n.language === "en"
        ? "Visit Start Date is required."
        : "تاريخ بدء الزيارة مطلوب."
    ),
    visitEndDate: Yup.string().required(
      i18n.language === "en"
        ? "Visit End Date  is required."
        : "تاريخ انتهاء الزيارة مطلوب."
    ),
    note: Yup.string(),
    reqAccessLevels: Yup.string().when([], {
      is: () => isSecurity,
      then: (schema) => schema.notRequired(),
      otherwise: (schema) =>
        schema.when("visitReqType", {
          is: VisitorType.VVIP,
          then: (schema) => schema.notRequired(),
          otherwise: (schema) =>
            schema.required(
              i18n.language === "en"
                ? "Request access levels is required."
                : "مستويات الوصول المطلوبة مطلوبة."
            ),
        }),
    }),
    accessLevels: Yup.string().when([], {
      is: () => isSecurity,
      then: (schema) =>
        schema.required(
          i18n.language === "en"
            ? "Access levels is required."
            : "مستويات الوصول مطلوبة"
        ),
      otherwise: (schema) => schema.notRequired(),
    }),

    uploadPhoto: Yup.mixed().notRequired(),
    uploadIqama: Yup.mixed().when("visitReqType", {
      is: VisitorType.VVIP,
      then: (schema) => schema.notRequired(),
      otherwise: (schema) =>
        schema.nullable().when("idType", {
          is: DOC_TYPE_ID.IQAMA,
          then: (schema) =>
            schema.required(
              i18n.language === "en"
                ? "Iqama upload is required."
                : "يتطلب تحميل الإقامة"
            ),
          otherwise: (schema) => schema.nullable(),
        }),
    }),

    uploadEid: Yup.mixed().when("visitReqType", {
      is: VisitorType.VVIP,
      then: (schema) => schema.notRequired(),
      otherwise: (schema) =>
        schema.nullable().when("idType", {
          is: DOC_TYPE_ID.NATIONAL_ID,
          then: (schema) =>
            schema.required(
              i18n.language === "en"
                ? "National ID upload is required."
                : "تحميل الهوية الوطنية مطلوب."
            ),
          otherwise: (schema) => schema.nullable(),
        }),
    }),
    uploadPassport: Yup.mixed().when("visitReqType", {
      is: VisitorType.VVIP,
      then: (schema) => schema.notRequired(),
      otherwise: (schema) =>
        schema.nullable().when("idType", {
          is: DOC_TYPE_ID.PASSPORT,
          then: (schema) =>
            schema.required(
              i18n.language === "en"
                ? "Passport upload is required."
                : "تحميل جواز السفر مطلوب."
            ),
          otherwise: (schema) => schema.nullable(),
        }),
    }),

    uploadIdOther: Yup.mixed().when("visitReqType", {
      is: VisitorType.VVIP,
      then: (schema) => schema.notRequired(),
      otherwise: (schema) =>
        schema.nullable().when("idType", {
          is: DOC_TYPE_ID.OTHER,
          then: (schema) =>
            schema.required(
              i18n.language === "en"
                ? "Other document upload is required."
                : "يتطلب تحميل مستند آخر"
            ),
          otherwise: (schema) => schema.nullable(),
        }),
    }),

    uploadVisa: Yup.mixed().when("visitReqType", {
      is: VisitorType.VVIP,
      then: (schema) => schema.notRequired(),
      otherwise: (schema) =>
        schema.nullable().when("idType", {
          is: DOC_TYPE_ID.VISA,
          then: (schema) =>
            schema.required(
              i18n.language === "en"
                ? "Visa upload is required."
                : "يجب تحميل التأشيرة."
            ),
          otherwise: (schema) => schema.nullable(),
        }),
    }),

    uploadVehicleRegLicense: Yup.mixed(),

    uploadHostEmployeeCard: Yup.mixed().required(
      i18n.language === "en"
        ? "Host employee card is required."
        : "بطاقة الموظف المضيف مطلوبة."
    ),

    vehicleNo: Yup.string(),
    // .matches(
    //   /^[A-Za-z0-9\u0621-\u064A\u0660-\u0669\- ]{0,10}$/,
    //   i18n.language === "en"
    //     ? "Enter a valid vehicle number."
    //     : "أدخل رقم السيارة الصحيح."
    // ),
  });
};
